<template>
  <CFooter class="footer-wrapper">
    <div>
      <a href="https://ufo-engineering.com/" target="_blank">UFO Engineering</a>
      <span class="ms-1">&copy;2015 - {{ new Date().getFullYear() }}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style lang="scss" scoped>
  .footer-wrapper {
    margin-top: 24px;
    background-color: white;
    z-index: 4;
  }
</style>
